export default __webpack_public_path__ + "static/media/eye.af92b0cf.svg";